import React from "react";
import { Box, Grid } from '@mui/material';
import {useNavigate} from "react-router-dom";
import classes from "../controls.module.scss";
import { CheckIsUserAdmin } from "../../../Shared/Utill/Utills";


    

const SpecialEventsControlsPage = () => {
    const navigate = useNavigate();
    CheckIsUserAdmin();

    return( 
            <div className={classes.pagemargin}>
            <div className={classes.pagetitle} >Special Events Controls </div>
            <div className={classes.pagesubtitle}>Select the task you'd like to perform. </div>

            <Grid container spacing={2} >
            <Grid key={2} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("eventcontrols")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Event Controls</div>
                    <div className={classes.textbtnsubtitle}>Manage your events.</div>
                </Box>
             </Grid>
            <Grid key={1} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("searchevent")}  component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Event Location Controls</div>
                    <div className={classes.textbtnsubtitle}>Manage your locations within an event.</div>
                </Box>
             </Grid>
             
             <Grid key={3} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("bulkadd")}  component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Bulk Add</div>
                    <div className={classes.textbtnsubtitle}>Update multiple event controls.</div>
                </Box>
            </Grid> 
            
             
             {/* <Grid key={4} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("bulkupdate")}   component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Bulk Update</div>
                    <div className={classes.textbtnsubtitle}>Apply controls to multiple divisions and stores.</div>
                </Box>
             </Grid> */}
            </Grid>
            </div>);

}

export default SpecialEventsControlsPage;